import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-data" }

import { ref, watch } from "vue";
import { useI18n } from "vue-i18n";

import type { TermType, TermPayloadType } from "@/common/types/term";

import { baseInput, baseTextEditor } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form-term',
  props: {
    data: {},
    isPatch: { type: Boolean },
    isEdit: { type: Boolean }
  },
  emits: ["update:data", "validate"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const DEFAULT_DATA = {
  name: "",
  description: null,
};

const payload = ref<TermPayloadType>({ ...DEFAULT_DATA });
const errors = ref<{ [key: string]: string }>({});

const isValid = ref(false);

function validate() {
  let free = [];

  Object.keys(payload.value).forEach((key) => {
    delete errors.value[key];

    if (
      (payload.value[key] === null ||
        payload.value[key] === "" ||
        payload.value[key] === undefined) &&
      !free.includes(key)
    )
      errors.value[key] = t("error.required");
  });

  isValid.value = Object.keys(errors.value).length === 0;
}

function update(key: keyof typeof payload.value) {
  validate();

  if (props.isPatch) {
    if (payload.value[key] === props.data[key]) return;

    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);

  setTimeout(() => emit("validate", isValid.value), 50);
}

function resumeData() {
  if (!props.data) return;

  const { name, description } = props.data;

  payload.value = {
    ...payload.value,
    name,
    description,
  };
}

watch(
  () => props.data,
  () => {
    resumeData();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(_unref(baseInput), {
      modelValue: payload.value.name,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.name) = $event)),
      value: payload.value.name,
      placeholder: _unref(t)('common.placeholders.name'),
      required: "",
      maxlength: "150",
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (update('name')))
    }, _createSlots({
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")) + " *", 1)
      ]),
      _: 2
    }, [
      (errors.value.name)
        ? {
            name: "error",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(errors.value.name), 1)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "value", "placeholder"]),
    _createVNode(_unref(baseTextEditor), {
      modelValue: payload.value.description,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.description) = $event)),
      onBlur: _cache[3] || (_cache[3] = ($event: any) => (update('description')))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)("category.labels.description")) + " *", 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})